// services/Products/Product.service.ts

import axiosInstance from "../../services/Instance/axiosInstance";
import { ProductTypes } from "../../services/Products/Product.types";

// ✅ GET all products



const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});
// services/Products/Product.service.ts
export const getAllProduct = async (): Promise<ProductTypes[]> => {
  try {
    const response = await axiosInstance.get<{ success: boolean; data: any[] }>("/getAllItems");

    if (response.data.success && Array.isArray(response.data.data)) {
      const mapped: ProductTypes[] = response.data.data.map((item) => ({
        // IDs
        id: item.id,
        product_id: item.id,

        // Article
        ArticleId: item.ArticleId,
        articleName: item.articleName,

        // Category
        categoryId: item.categoryId,
        category_name: item.category_name,

        // Metal
        MetalTypeId: item.MetalTypeId,
        purity: item.purity,
        karat: item.karat,
        carat: item.carat,
        centValue: item.centValue,

        // UOM
        UomId: item.UomId,

        // Description
        description: item.description,

        // Price
        price: item.price,

        // Images
        image: item.image,
        thumbnail_image: item.image,
        tunchImage: item.tunchImage,

        // Quantity and Weight
        quantity: item.quantity,
        weight: item.weight,

        // Dimensions
        Dimensions: item.Dimensions,

        // Charges
        wastage: item.wastage,
        makingCharges: item.makingCharges,

        // T2T
        t2t: item.t2t,
        difference: item.difference,

        // Status
        availabilityStatus: item.availabilityStatus,
        status: item.status,

        // Metadata
        isActive: item.isActive,
        isDelete: item.isDelete,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,

        // Nested objects
        article_master: item.article_master ?? null,
        category: item.category ?? null,
        buyers_sellers_detail: item.buyers_sellers_detail ?? null,
        
        // ✅ INVENTORY MAP KARO
        inventory: item.inventory ?? null,

        // Default values
        name: item.articleName || `Product ${item.id}`,
        thickness: 0,
        diameter: 0,
        MetalTypeName: item.MetalTypeName,
      }));

      return mapped;
    }

    return [];
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

// ✅ CREATE product - FIXED VERSION
// In Product.service.ts
export const createProduct = async (productData: Record<string, any>): Promise<ProductTypes> => {
  try {
    // console.log("errr")
    // If no files, send as JSON (not FormData)
    const response = await axiosInstance.post<{ success: boolean; message: string; data: ProductTypes }>(
      "/admin/items",
      productData,  // Send as JSON, not FormData
      {
        headers: {
          "Content-Type": "application/json"  // Use JSON, not multipart
        },
      }
    );

    if (response.data.success) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || "Failed to create product");
    }
  } catch (error) {
    console.error("Create product error:", error);
    throw error;
  }
};

// ✅ GET product by ID
export const getByIdProduct = async (id: string | number): Promise<ProductTypes> => {
  try {
    const response = await axiosInstance.get<{ success: boolean; data: ProductTypes }>(`/item/${id}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

// ✅ UPDATE product
export const updateProductApi = async (id: string | number, productData: Record<string, any>): Promise<ProductTypes> => {
  try {
    // Use correct endpoint: /item/{id} with PUT method
    const response = await axiosInstance.put<{ success: boolean; message: string; data: ProductTypes }>(
      `/item/${id}`,
      productData,
      {
        headers: {
          "Content-Type": "application/json", // JSON data bhej rahe hain
        },
      }
    );

    if (response.data.success) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || "Failed to update product");
    }
  } catch (error) {
    console.error("Update product error:", error);
    throw error;
  }
};



// ✅ DELETE product - Using axiosInstance instead of fetch
export const deleteProduct = async (id: number): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await axiosInstance.delete(`/item/${id}`);

    // Agar response directly data return karta hai
    if (response.data) {
      return response.data;
    }

    // Agar response.data.success pattern follow karta hai
    return { success: true, message: "Product deleted successfully" };
  } catch (error: any) {
    console.error("Error deleting product:", error);

    // Agar error response mein message ho to use karein
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }

};


export const updateProductStatusApi = async (id: number, data: any) => {
  const response = await axiosInstance.patch(`/admin/items/approve/${id}`, data);
  return response.data;
};

export const toggleProductActiveApi = async (id: number) => {
  const res = await axiosInstance.put(`/item/status/${id}`);
  return res.data;
};